import { render, staticRenderFns } from "./RoleDetailTable.vue?vue&type=template&id=4ecbe30b&scoped=true"
import script from "./RoleDetailTable.vue?vue&type=script&lang=js"
export * from "./RoleDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecbe30b",
  null
  
)

export default component.exports